import React from "react";

export function Grid({ children }) {
  return (
    <div class="row row-cols-2  row-cols-md-3 row-cols-lg-4 row-cols-xl-6 g-3">
      {children}
    </div>
  );
}
